import './utils/dev-session-refresh';

import FlagProvider from '@unleash/proxy-client-react';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { object } from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';

import { withGuard } from './generic/change-guard';
import GlobalErrorBoundary from './layout/GlobalErrorBoundary';
import Routes from './layout/Routes';
import SessionContext from './signin/SessionContext';
import * as Session from './utils/session';
import { createUnleashConfig, isUnleashEnabled } from './utils/unleash';

const RoutesWithGuard = withGuard(Routes);

class Root extends React.Component {
  constructor(props) {
    super(props);

    this.state = { session: Session.read() };

    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    this.tickInterval = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.tickInterval);
  }

  tick() {
    const newSession = Session.read();
    const oldUser = get(this.state, 'session.user', null);
    const oldToken = get(this.state, 'session.token', null);
    const newUser = get(newSession, 'user', null);
    const newToken = get(newSession, 'token', null);

    if (oldToken !== newToken || !isEqual(oldUser, newUser)) {
      this.setState({
        session: newSession,
      });
    }
  }

  render() {
    const { store } = this.props;
    const { session } = this.state;

    // Create Unleash config with user ID from session for proper user tracking
    const unleashConfig = createUnleashConfig({
      userId: get(session, 'user.id', null),
    });

    // Render app with FlagProvider only if Unleash is enabled
    const appContent = (
      <GlobalErrorBoundary>
        <SessionContext.Provider value={session}>
          <RoutesWithGuard />
        </SessionContext.Provider>
      </GlobalErrorBoundary>
    );

    return (
      <Provider store={store}>
        {isUnleashEnabled() ? (
          <FlagProvider config={unleashConfig}>{appContent}</FlagProvider>
        ) : (
          appContent
        )}
      </Provider>
    );
  }
}

Root.propTypes = {
  store: object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default Root;
